// extracted by mini-css-extract-plugin
export default {"pageWrap":"lb-z","fullWidth":"mb-z","heading":"nb-z","fullBleed":"ob-z","hidden":"pb-z"};